import React from "react";

import { useCountUp } from "../hooks/useCountUp";

/**
 * Numero animado (cuenta hacia arriba al montar).
 * Reserva el ancho del valor final y usa cifras tabulares para que al subir
 * no cambie el layout ni se recorte el texto.
 *
 * @param {number}   to
 * @param {number}   duration
 * @param {function} format
 * @param {number}   decimals
 * @param {string}   prefix
 * @param {string}   suffix
 */
function CountUp({ to, duration = 1200, format, decimals = 0, prefix = "", suffix = "" }) {
    const v = useCountUp(to, { duration });

    const formatValue = (n) => {
        if (format) return format(n);
        if (decimals) return Number(n).toFixed(decimals);
        return String(Math.round(n));
    };

    const shown = formatValue(v);
    const finalShown = formatValue(to);
    // Ancho reservado = valor final (+ prefijo/sufijo) para no "clipear" al crecer.
    const reserve = `${prefix}${finalShown}${suffix}`;

    return (
        <span
            style={{
                display: "inline-block",
                minWidth: `${Math.max(reserve.length, 1)}ch`,
                fontVariantNumeric: "tabular-nums",
                textAlign: "inherit",
                whiteSpace: "nowrap",
            }}
        >
            {prefix}
            {shown}
            {suffix}
        </span>
    );
}

export default CountUp;
